import React from 'react'

const DEFAULT_COLORS = {
  active: '#FFFFFF',
  inactive: '#2D264B',
  stroke: '#FFFFFF',
}

const AimIcon = ({ isActive, color, width = 24, height = 24, ...props }) => {
  const styles = {
    stroke: color
      ? DEFAULT_COLORS.stroke
      : isActive
      ? DEFAULT_COLORS.active
      : DEFAULT_COLORS.inactive,
    fill: color || 'none',
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={styles.fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 10H7.5M16.5 10H20.5"
        stroke={styles.stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10.4721C3 10.1616 3.07229 9.85542 3.21115 9.57771L5.44721 5.10557C5.786 4.428 6.47852 4 7.23607 4H16.7639C17.5215 4 18.214 4.428 18.5528 5.10557L20.7889 9.57771C20.9277 9.85542 21 10.1616 21 10.4721V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V10.4721Z"
        stroke={styles.stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.4709V7"
        stroke={styles.stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 12L12.085 15.2757L9.169 12"
        stroke={styles.stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AimIcon
